import { Row, Col } from "antd";
import { Typography, TextField, FormControl, RadioGroup, Radio, FormControlLabel, Switch } from "@mui/material";
import moment from 'moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import { SelectedIcon, UnSelectedIcon } from "../../../../../Shared/components/Icons/selectedIcon";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";

export const HeaderView = (props) => {
    const { classes, clsx, form, status, view, lines, idNamingConversion, unitMesurementdetails, customerDetails, supplierApi, supplierDetails, customObject, changeHandler, error, customerApi } = props;

    return (
        <>
            <Row gutter={50}>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Row gutter={30}>
                         <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Adjust Stock Number</Typography>
                            <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.serialNo || '---'} </Typography>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            <span className={clsx(classes.statusButton, { [classes.confirmedButton]: status === 'CONFIRMED' })}>{status || 'CREATED'}</span>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            {
                                view ? <>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Default Unit</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.unit?.name || '---'} </Typography>
                                </> : <AutoCompleteComponent
                                    name={["Default Unit "]}
                                    heads={[{ 'key': 'name', 'name': 'Unit' },
                                    { 'key': 'description', 'name': 'Description' }]}
                                    details={unitMesurementdetails}
                                    parentValue={customObject(unitMesurementdetails, form?.unitId)}
                                    id={idNamingConversion('Unit', 'salesBillLine', 'DropDown')}
                                    onChange={(data) => changeHandler(data, 'unitId', 'unit')}
                                    position={"bottom"}
                                />
                            }
                        </Col>
                    </Row>
                    <Row gutter={30}>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Transaction Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.transactionDate ? moment(form.transactionDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> :
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                tabIndex={-1}
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={form?.transactionDate || null}
                                                label="Transaction Date"
                                                PopperProps={{
                                                    className: classes.dateAdjust,
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('Transaction Date', 'adjustStock', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError || newValue === null) {
                                                        changeHandler(new Date(), 'transactionDate');
                                                    } else {
                                                        changeHandler(newValue, 'transactionDate');
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                }
                            </div>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Description </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.description || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Description "]}
                                        fullWidth
                                        name={"description"}
                                        id={idNamingConversion('Description', 'stockTransfer', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        variant={'standard'}
                                        value={form?.description || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e.target.value, 'description')}
                                    />
                            }
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Created Date</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.createTs ? moment(form.createTs).format('DD MMM YYYY') : '---'}</Typography>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>User Name</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.createdBy || '---'}</Typography>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Enable Services</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.enableServices ? 'Yes' : 'No'}</Typography>
                                </> :
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                        }}
                                        id={idNamingConversion('Enable Services', 'adjustStock', 'Radio')}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => changeHandler(!form?.enableServices, 'enableServices')}
                                        />}
                                        label="Enable Services"
                                        labelPlacement="top"
                                        disabled={lines?.length > 0 ? true : false}
                                        checked={form?.enableServices}
                                        className={clsx(classes.marginLeft0, classes.margin30t, classes.flexStart)}
                                    />
                            }
                        </Col>
                    </Row>
                    <Row gutter={30}>
                        {
                            form?.enableServices ? <>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                    {
                                        view ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Type </Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.serviceType || '---'}</Typography>
                                        </> :
                                            <FormControl
                                                className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.margin30t)}
                                                variant={'standard'}
                                                disabled={lines?.length > 0 ? true : false}
                                                fullWidth>
                                                <RadioGroup
                                                    value={form?.serviceType}
                                                    onChange={(e) => changeHandler(e.target.value, 'serviceType')}>
                                                    <FormControlLabel value="SERVICE BILL" control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="Service Bill" />
                                                    <FormControlLabel value="JOB WORK" control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="Job Work" />
                                                </RadioGroup>
                                            </FormControl>
                                    }
                                </Col>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                    {
                                        form?.serviceType === 'SERVICE BILL' ?
                                            <>
                                                {
                                                    view ? <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Customer Name </Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.name || '---'}</Typography>
                                                    </> : <AutoCompleteComponent
                                                        name={["Customer Name "]}
                                                        heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                                        { 'key': 'mobile', 'name': 'Phone Number' },
                                                        { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                                        details={customerDetails}
                                                        id={idNamingConversion('Customer Name', 'adjustStock', 'DropDown')}
                                                        parentValue={customObject(customerDetails, form?.customerId)}
                                                        onChange={(data) => { changeHandler(data, 'customerId', 'customer') }}
                                                        searchType={(s) => customerApi(s)}
                                                        parentError={error?.customerId}
                                                        disabled={lines?.length > 0 ? true : false}
                                                        position={"bottom"}
                                                        customClasses={classes.margin30t}
                                                    />
                                                }
                                            </>
                                            : <>{
                                                view ? <>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Supplier Name </Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.supplier?.name || '---'}</Typography>
                                                </> : <AutoCompleteComponent
                                                    name={["Supplier Name "]}
                                                    heads={[{ 'key': 'name', 'name': 'Supplier Name' },
                                                    { 'key': 'mobile', 'name': 'Phone Number' },
                                                    { 'key': 'serialNo', 'name': 'Supplier ID' }]}
                                                    details={supplierDetails}
                                                    id={idNamingConversion('Supplier Name', 'adjustStock', 'DropDown')}
                                                    parentValue={customObject(supplierDetails, form?.supplierId)}
                                                    onChange={(data) => { changeHandler(data, 'supplierId', 'supplier') }}
                                                    searchType={(s) => supplierApi(s)}
                                                    parentError={error?.supplierId}
                                                    disabled={lines?.length > 0 ? true : false}
                                                    position={"bottom"}
                                                    customClasses={classes.margin30t}
                                                />
                                            }
                                            </>
                                    }
                                </Col>
                            </> : null
                        }
                    </Row>
                </Col>
            </Row>
        </>
    )
}